<template>
  <div class="scrollbox">
    <div class="scrollcontent" style="height: 100%;">
      <slot></slot>
    </div>
  </div>
</template>

<script setup>
</script>

<style scoped>
  .scrollbox {
    overflow-x: hidden;
    overflow-y: auto;
    visibility: hidden;
    /* scrollbar-width: thin; */
  }
  .scrollcontent,
  .scrollbox:hover,
  .scrollbox:focus {
    visibility: visible;
  }
</style>